require('shufflejs');
require('modernizr');
require('../../node_modules/mediaelement/build/mediaelementplayer');

$(document).ready(() => {

    let $grid = $('#grid'),
        $filterOptions = $('.filter-options');

    $grid.shuffle({
        itemSelector: '.project',
        speed: 400
    });

    if ($('.site__carousel-thumbs').length) {
        $('video').mediaelementplayer({});
    }

    let setupFilters = function() {
        let $btns = $filterOptions.children();
        $btns.on('click', function() {
            let $this = $(this),
                isActive = $this.hasClass( 'active' ),
                group = isActive ? 'all' : $this.data('group');

            if ( !isActive ) {
                $('.filter-options .active').removeClass('active');
            }

            $this.toggleClass('active');

            $grid.shuffle( 'shuffle', group );
        });

        $(".select-options").on("change", function() {
            let group = $(this).val();
            $grid.shuffle( 'shuffle', group );
        });

        $btns = null;
    };

    setupFilters();


    let currentProject = $('.project-page').data("project");

    if(currentProject) {
        $.get('projetos.json', function(data) {

            let projectsList = data.filter(function(item) {
                return item.status == "NO AR";
            });

            let project = projectsList.filter(function(item) {
                return item.slug === currentProject;
            })[0];

            let projectIndex = projectsList.indexOf(project);

            let next, previous;

            previous = (projectIndex === 0) ? projectsList[projectsList.length - 1] : projectsList[projectIndex - 1];

            next = (projectIndex === projectsList.length - 1) ? projectsList[0] : projectsList[projectIndex + 1];

            $(".previous-project").attr('href', next.url);
            $(".next-project").attr('href', previous.url);
        });


        let keymap = {};

        // LEFT
        keymap[ 37 ] = ".previous-project";
        // RIGHT
        keymap[ 39 ] = ".next-project";
        // DELETE
        keymap[ 8 ] = ".all-projects";

        $( document ).on( "keyup", function(event) {
            let href,
                selector = keymap[ event.which ];
            console.log(event.which);
            // if the key pressed was in our map, check for the href
            if ( selector ) {
                href = $( selector ).attr( "href" );
                if ( href ) {
                    // navigate where the link points
                    (<any>window).location = href;
                }
            }
        });
    }

});


// WEBPACK FOOTER //
// ./src/js/projetos.ts